<template lang="pug">
    section#formulario
        .wrapper
            h2 Preencha o formulário abaixo e acesse o link para entrar na nossa 
                strong lista exclusiva
            .form
                form(@submit.prevent="sendFormulario")
                    p Preencha TODOS os campos abaixo
                    .input
                        input(v-model="form.nome", type="text", placeholder="Nome")
                        span.erro(v-if='errors.nome') {{ errors.nome[0] }}
                    .input
                        input(v-model="form.email", type="text", placeholder="E-mail")
                        span.erro(v-if='errors.email') {{ errors.email[0] }}
                    .input
                        input(v-model="form.telefone", type="text", placeholder="Telefone",  v-mask="'(##) #####-####'")
                        span.erro(v-if='errors.telefone') {{ errors.telefone[0] }}
                    .input
                        input(v-model="form.cidade", type="text", placeholder="Cidade")
                        span.erro(v-if='errors.cidade') {{ errors.cidade[0] }}
                    .group
                        .input
                            select(v-model="form.ano")
                                option(disabled, value="", selected) Realizou o enem em qual ano
                                option(value="2022") 2022
                                option(value="2021") 2021
                                option(value="2020") 2020
                                option(value="2019") 2019
                                option(value="2018") 2018
                                option(value="2017") 2017
                                option(value="2016") 2016
                                option(value="2015") 2015
                                option(value="2014") 2014
                                option(value="2013") 2013
                                option(value="2012") 2012
                                option(value="2011") 2011
                                option(value="Antes de 2011") Antes de 2011
                            span.erro(v-if='errors.ano') {{ errors.ano[0] }}
                        .input
                            select(v-model="form.formacao")
                                option(disabled, value="", selected) Formação Acadêmica
                                option(value="Ensino Médio incompleto") Ensino Médio incompleto
                                option(value="Ensino Médio completo") Ensino Médio completo
                                option(value="Ensino Superior incompleto") Ensino Superior incompleto
                                option(value="Ensino Superior completo") Ensino Superior completo
                            span.erro(v-if='errors.formacao') {{ errors.formacao[0] }}
                    button(type="submit" :disabled="disabled", v-html="textButton")
        aside(v-if="enviado" @click.self="enviado = false")
            .wrapper
                p Obrigado!
                    br
                    | Clique no botão para ter acesso a nossa LISTA EXCLUSIVA.
                a(href="https://chat.whatsapp.com/GAb6ZF0i48U707ZKIbhZxF", target="_blank") LISTA EXCLUSIVA
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    name: "section-formulario",
    data() {
        return {
            form: {
                nome: '',
                email: '',
                telefone: '',
                cidade: '',
                ano: '',
                formacao: '',
            },
            errors: {},
            disabled: false,
            enviado: false,
            textButton: "Cadastro"
        }
    },
    directives: {
        mask,
    },
    methods: {
        sendFormulario() {
            this.disabled = true
            this.errors = {}
            this.textButton = 'Enviando...'
            this.$axios
                .post(`lead/prouni`, this.form)
                .then(() => {
                    this.textButton = 'Enviado!'
                    this.form = Object.assign({}, {
                        nome: '',
                        email: '',
                        telefone: '',
                        cidade: '',
                        ano: '',
                        formacao: '',
                    })
                    this.enviado = true
                })
                .catch(error => {
                    this.errors = error.response.data.error_validate
                    this.textButton = 'Tente novamente'
                })
                .finally(() => {
                    setTimeout(() => {
                        this.textButton = 'Enviar'
                        this.disabled = false
                    }, 5000)
                })
        },
    }
}
</script>

<style lang="stylus" scoped src="./Formulario.styl"></style>